import { render, staticRenderFns } from "./InterviewCodePage.vue?vue&type=template&id=fb55fa54"
import script from "./InterviewCodePage.vue?vue&type=script&lang=js"
export * from "./InterviewCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports